import { CSVUpload as CSVUploadAPI } from '@occc-app/Activate/apiTypes';

import { CSVUpload as CSVUploadClient } from './types';

type ActionClient = CSVUploadClient['action'];
type ConfigClient = CSVUploadClient['config'];

type SerializeAction = (actionClient: ActionClient) => CSVUploadAPI['attributes']['action'];
const serializeAction: SerializeAction = (actionClient) => {
  switch (actionClient) {
    case 'addSegmentMemberships':
      return 'add_segment_memberships';
  }
};

type SerializeConfig = (action: ActionClient, config: ConfigClient, formData: FormData) => void;
const serializeConfig: SerializeConfig = (action, config, formData) => {
  switch (action) {
    case 'addSegmentMemberships':
      formData.append('data[attributes][config][segment_id]', config.segmentId);
      formData.append('data[attributes][config][has_header_row]', config.hasHeader.toString());
      formData.append(
        'data[attributes][config][membership_column_index]',
        config.membershipColumnIndex.toString(),
      );
  }
};

type CreateConfig = {
  action: ActionClient;
  chainId: string;
  config: ConfigClient;
  file: File;
};
type SerializeCSVUploadCreate = (createConfig: CreateConfig) => FormData;
export const serializeCSVUploadCreate: SerializeCSVUploadCreate = ({
  action,
  chainId,
  config,
  file,
}) => {
  const formData = new FormData();
  formData.append('data[type]', 'csv_uploads');
  formData.append('data[relationships][chain][data][type]', 'chains');
  formData.append('data[relationships][chain][data][id]', chainId);
  formData.append('data[attributes][action]', serializeAction(action));
  serializeConfig(action, config, formData);
  formData.append('data[attributes][file]', file);
  return formData;
};
